import type { CrLogType, CrLogTypeDef, CrTabDef } from './types';

export const GROWTH_CAMPAIGN_REPORT_META = {
  eyebrow: 'Google Ads · Campaign Report',
  titleLead: 'Emergency Dental —',
  titleAccent: 'Same Day',
  description:
    'Running since March 12, 2026 · Emergency cluster · CTA: Book Appointment. Every metric below reflects real booked appointments and attributed revenue, not just ad clicks.',
} as const;

export const CR_TABS: CrTabDef[] = [
  { id: 'overview', label: 'Overview' },
  { id: 'keywords', label: 'Keywords' },
  { id: 'ads', label: 'Ads' },
  { id: 'log', label: 'ELVA Log' },
];

export const CR_LOG_TYPES: Record<CrLogType, CrLogTypeDef> = {
  budget: { label: 'Budget', icon: 'dollar' },
  keyword: { label: 'Keyword', icon: 'search' },
  ad: { label: 'Ad Copy', icon: 'doc' },
  schedule: { label: 'Schedule', icon: 'calendar' },
  geo: { label: 'Targeting', icon: 'pin' },
  launch: { label: 'Launch', icon: 'bolt' },
};
